module.exports = __webpack_public_path__ + "static/img/headImg.ff14eeed.png";